module.exports = __webpack_public_path__ + "static/media/cancel_white.6de057fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/cancel_white.svg
// module id = 18
// module chunks = 0